import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../../components/api/Request";
import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, parseApiDate ,showDialog} from "../../../utils/Utils";
 
 

const TesvikKanunuDetail = (props) => {

    const dispatch = useDispatch();

    const [tesvikKanunu, setTesvikKanunu] = useState();
    useEffect(() => {
        getTesvikKanunu();
    }, [])

    const getTesvikKanunu = () => {

        let data = {state:true};
        if (props.data.id) {
            const request = new Request("/tesvikkanunu/getKayit/" + props.data.id, "GET");
            return request.run()
                .then(response => {
                    if (response.data) {
                        data = response.data.data
                    }
                    setTesvikKanunu(data);
                });
        } else {
            setTesvikKanunu(data);
        }
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        let data = tesvikKanunu;

        let url = "/tesvikkanunu/createKayit";
        let methodName ="POST";
        if(data.id != null){
            url = "/tesvikkanunu/updateKayit";
            methodName ="PUT";
        } 
        const request = new Request(url, methodName, data);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }else{
                    let mesaj ="";
                    if(response && response.response && response.response.data && response.response.data.message){
                        mesaj =response.response.data.message;
                    }
                    showDialog({ title: 'Teşvik Kanunu kayıt', message: mesaj , buttons: "OK" });
                }
            });
    }


    return (
        <div >
            <Form formData={tesvikKanunu} colCount={1} id="form" labelLocation={"left"} className="option" >
                
            <Item itemType="group" colCount={1} colSpan={1}>
                        <Item disabled={true} dataField={'kanunNumarasi'} editorType={'dxTextBox'} >
                            <Label text='Kanun No' />
                        </Item>
                    </Item>
                    <Item itemType="group" colCount={1} colSpan={1}>
                        <Item disabled={false} dataField={'adi'} editorType={'dxTextBox'} >
                            <Label text='Adı' />
                        </Item>
                    </Item>
                    <Item disabled={false} dataField={'devreDisiBirakilabilir'} editorType={'dxCheckBox'}>
                            <Label text='Devre Dışı Bırakılabilir' />
                        </Item>
 
                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default TesvikKanunuDetail;
